import EmptyState from '../components/EmptyState';

export default function Paremiology() {
  return (
    <EmptyState
      title="Paremiology"
      description="Proverbs, idioms, and fixed expressions via KUSH enrichment"
    />
  );
}
